import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const applySettingsToProperty = createAsyncThunk<
    { message: string },
    {
        mode: string;
        preferredSuppliersIds: string[];
        propertyId: string;
        orderType: string;
        sortingMode: string;
    },
    ThunkConfig<string>
>(
    'applySettingsToProperty',
    async (
        { mode, preferredSuppliersIds, propertyId, orderType, sortingMode },
        thunkApi,
    ) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const response = await extra.api.post<{ message: string }>(
                `/v1/product_sourcing/settings/${propertyId}`,
                { mode, preferredSuppliersIds, orderType, sortingMode },
            );

            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
